import { render, staticRenderFns } from "./SchemaPresetComponent.vue?vue&type=template&id=3457b29c"
import script from "./SchemaPresetComponent.vue?vue&type=script&lang=ts"
export * from "./SchemaPresetComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports